import { JargonTranslation } from './jargonTypes'

export const enUS: JargonTranslation = {
  abnEntity: 'a unique business number',
  abn: 'Business Number',
  abnLowercase: 'business number',
  abnSearchName: 'Unknown',
  abns: 'Business Numbers',
  abnsLowercase: 'business numbers',
  companyInduction: 'Company Orientation',
  companyInductions: 'Company Orientations',
  defect: 'Defect',
  defects: 'Defects',
  drawing: 'Drawing',
  drawings: 'Drawings',
  favourite: 'Favorite',
  favourites: 'Favorites',
  induct: 'Orient',
  inducts: 'Orients',
  inducted: 'Orientated',
  inducting: 'Orientating',
  induction: 'Orientation',
  inductions: 'Orientations',
  itp: 'ITP',
  itps: 'ITPs',
  people: 'Personnel',
  peoples: 'Personnel',
  project: 'Project',
  projects: 'Projects',
  preStart: 'Notices',
  preStarts: 'Notices',
  projectHoursBudget: 'Project Labor Budget',
  projectHoursBudgets: 'Project Labor Budgets',
  placeholderAddress: '123 Main St, Springfield, IL 62704',
  placeholderProjectName: '123 Main St',
  placeholderPhoneNumber: '255 555 5555',
  register: 'Log',
  registers: 'Logs',
  sdsLibrary: 'SDS Library',
  sdsLibraries: 'SDS Libraries',
  signOn: 'Sign on',
  signOns: 'Sign ons',
  siteInduction: 'Site Orientation',
  siteInductions: 'Site Orientations',
  siteDiary: 'Diary Log',
  siteDiaries: 'Diary Logs',
  staff: 'Staff',
  staffs: 'Staffs',
  subcontractor: 'Company',
  subcontractors: 'Companies',
  swms: 'JSA',
  swmss: 'JSAs',
  swmsFullTitle: 'Job Safety Analysis',
  ticket: 'Certification',
  tickets: 'Certifications',
  timesheet: 'Timesheet',
  timesheets: 'Timesheets',
  worker: 'Worker',
  workers: 'Workers',
}
